<mat-card class="width-100 mat-elevation-z0">
    <mat-card-content>
        <form [formGroup]="newParcelForm">
            <app-import-payments-select-file formControlName="file"
                                             class="width-100">
            </app-import-payments-select-file>
            <app-simple-autocomplete-value-accessor label="Typ zawartości"
                                                    [data]="contentTypes"
                                                    formControlName="contentTypeId"
                                                    [required]="true"
                                                    (changed)="onTypeSelected($event)">
            </app-simple-autocomplete-value-accessor>
            <app-simple-autocomplete-value-accessor label="Typ przesyłki"
                                                    [data]="types"
                                                    formControlName="typeId"
                                                    [required]="true">
            </app-simple-autocomplete-value-accessor>
            <ng-container parcelStrategy></ng-container>
            <div class="parcel-attachment-required-checkbox">
                <app-simple-checkbox-value-accessor label="Dołączyć RODO"
                                                    formControlName="attachRodo">
                </app-simple-checkbox-value-accessor>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions>
        <div class="button-container">
            <button action-button
                    class="width-100"
                    mat-raised-button
                    color="primary"
                    type="button"
                    [action]="createParcel.bind(this)"
                    [disabled]="!newParcelForm.valid">
                Stwórz przesyłkę
            </button>
        </div>
    </mat-card-actions>
</mat-card>
